import styled from 'styled-components';

const BlogListStyle = styled.div`
	.blogItemWrap {
		padding-top: var(--sp12x);
		position: relative;
		z-index: 11;
		overflow: hidden;

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
			padding-top: var(--sp14x);
		}
	}
`;

export default BlogListStyle;
